import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  AUTH_LOCALSTORAGE_NAME,
  EMPLOYEE_MANAGE_API,
} from "../constants/constants";

export const employeeServiceApi = createApi({
  reducerPath: "employeeServiceApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: EMPLOYEE_MANAGE_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        if (token) {
          headers.set("Authorization", `Bearer ${token}`);
        }

        headers.set("ngrok-skip-browser-warning", "true");

        return headers;
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    if (
      result.error &&
      result.error?.status === 401 &&
      (result?.error?.data as any)?.message === "Unauthorized"
    ) {
      localStorage.removeItem(AUTH_LOCALSTORAGE_NAME);
      window.location.reload();
    }

    return result;
  },
  tagTypes: [
    "GetDepartments",
    "GetDepartmentDetails",
    "GetDesignations",
    "GetDesignationDetails",
    "GetEmployees",
    "GetEmployeeDetails",
    "GetEmployeeAdditionalFields",
    "GetEmployeeAdditionalFieldDetails",
    "GetWorkStations",
    "GetWorkStationDetails",
    "GetExpenseUnits",
    "GetExpenseUnitDetails",
  ],
  endpoints: () => ({}),
});
